/**
 * Dev-only console wrappers.
 *
 * In production builds these become no-ops so we don't leak diagnostic
 * information or slow the console. Prefer these over `console.*` directly.
 */
const IS_DEV = process.env.NODE_ENV !== "production";

export const devWarn = (...args) => {
  if (IS_DEV) console.warn(...args);
};

export const devError = (...args) => {
  if (IS_DEV) console.error(...args);
};
